export const ASSIGNED = 1;
export const UNASSIGNED = 2;
export const COMPLETED = 3;
export const PARTICIPANT_CONTENT_STATUS = { ASSIGNED, UNASSIGNED, COMPLETED };

export const getContentStatus = (statusId) => {
  let contentStatus = null;

  switch (statusId) {
    case ASSIGNED:
      contentStatus = "To Watch";
      break;
    case UNASSIGNED:
      contentStatus = "Unassigned";
      break;
    case COMPLETED:
      contentStatus = "Watched";
      break;
    default:
      break;
  }

  return contentStatus;
};

export const getContentStatusFromAllAvailableContent = (statusId) => {
  let contentStatus = null;

  switch (statusId) {
    case ASSIGNED:
      contentStatus = "Assigned";
      break;
    case COMPLETED:
      contentStatus = "Watched";
      break;
    default:
      break;
  }

  return contentStatus;
};
